import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import OrderList from "./tabItems/OrderList";
import AddOrder from "./tabItems/AddOrder";
import { setOrder } from "../../store/slices/orderSlice";
import AllOrders from "./tabItems/AllOrders";

export const orderTabConfig = {
    LIST: "1",
    ADD: "2",
    ALL: "3"
}

const OrdersTab = () => {
    const [currentTab, setCurrentTab] = useState(orderTabConfig.LIST);
    const [tabTada, setTabData] = useState({});
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(setOrder({}));
    }, [])

    const onSwitchTab = (key, data) => {
        setCurrentTab(key);
    } 

    const tabs = [
        // {
        //     key: orderTabConfig.ADD,
        //     label: 'New Order',
        //     children: <AddOrder onSwitchTab={onSwitchTab} tabProps={{}} />,
        // },
        {
          key: orderTabConfig.LIST,
          label: 'Order List',
          children: <OrderList onSwitchTab={onSwitchTab} />,
        },
        {
          key: orderTabConfig.ALL,
          label: 'All Orders List',
          children: <AllOrders onSwitchTab={onSwitchTab} />,
        }
    ];

    const onChange = (key) => {
        setCurrentTab(key);
        if (key !== orderTabConfig.ADD) {
            dispatch(setOrder({}));
        }
    };

    return (
        <div>
            <div className="text-2xl pb-3">Orders</div>
        <div className="px-4 border pb-6 bg-white pop-left">
                <Tabs defaultActiveKey="1" activeKey={currentTab} items={tabs} onChange={onChange} />
            </div>
        </div>
    )
}

export default OrdersTab;